import Hero from "../components/Hero";
import hotelImg from "../assests/images/hotel-bg.jpg";
import { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

export default function Faqs() {
    const faqs = [
        {
            question: "How do I book a hotel?",
            answer:
                "You can browse hotels on our website, select your preferred option, and complete the booking with instant confirmation.",
        },
        {
            question: "Can I cancel my booking?",
            answer:
                "Yes, most bookings are refundable. Cancellation policy depends on the hotel or service provider.",
        },
        {
            question: "How do I get visa assistance?",
            answer:
                "You can apply through our visa services section. Our team will guide you through the entire process.",
        },
        {
            question: "Do you offer flight booking support?",
            answer:
                "Yes, we provide affordable flight booking options worldwide with flexible dates and airlines.",
        },
        {
            question: "Is my payment secure?",
            answer:
                "Yes, all payments are encrypted and processed through secure gateways to ensure full protection.",
        },
        {
            question: "Do you provide 24/7 customer support?",
            answer:
                "Absolutely! Our support team is available 24/7 to assist you with any travel-related queries.",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (

        <>

            <Helmet>
                <title>
                    FAQs | Dubai Cheap Hotels - Frequently Asked Questions
                </title>

                <meta
                    name="description"
                    content="Find answers to frequently asked questions about booking affordable hotels in Dubai, payments, cancellations, refunds, and travel services at Dubai Cheap Hotels."
                />

                <link
                    rel="canonical"
                    href="https://dubaicheaphotels.com/faqs"
                />

                {/* Open Graph */}
                <meta property="og:title" content="FAQs | Dubai Cheap Hotels" />
                <meta
                    property="og:description"
                    content="Find answers to frequently asked questions about booking affordable hotels in Dubai, payments, cancellations, refunds, and travel services."
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:url"
                    content="https://dubaicheaphotels.com/faqs"
                />
                <meta
                    property="og:image"
                    content="https://dubaicheaphotels.com/images/default-og.png"
                />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="FAQs | Dubai Cheap Hotels" />
                <meta
                    name="twitter:description"
                    content="Find answers to frequently asked questions about booking affordable hotels in Dubai, payments, cancellations, refunds, and travel services."
                />
                <meta
                    name="twitter:image"
                    content="https://dubaicheaphotels.com/images/default-og.png"
                />

                {/* SEO Rules */}
                <meta name="robots" content="index, follow" />
            </Helmet>
            <div className="w-full bg-gradient-to-b from-white to-orange-50">

                {/* HERO */}
                <Hero
                    variant="inner"
                    title="Frequently Asked Questions"
                    subtitle="Find answers to common travel and booking questions"
                    backgroundImage={hotelImg}
                />

                {/* FAQ SECTION */}
                <div className="max-w-5xl mx-auto px-4 py-20">
                    <h2 className="text-4xl font-bold text-center mb-4 text-gray-800">
                        FAQs
                    </h2>
                    <p className="text-center text-gray-500 mb-12">
                        Everything you need to know about booking and travel
                    </p>

                    <div className="space-y-5">
                        {faqs.map((item, index) => (
                            <div
                                key={index}
                                className={`rounded-2xl border transition-all duration-300 
                            ${activeIndex === index
                                        ? "bg-white shadow-lg border-[#FF6B35]"
                                        : "bg-white hover:shadow-md border-orange-100 hover:border-[#FF6B35]"
                                    }`}
                            >
                                {/* Question */}
                                <button
                                    onClick={() => toggleFAQ(index)}
                                    className="w-full flex justify-between items-center px-6 py-5 text-left"
                                >
                                    <span className="text-lg font-semibold text-[#FF6B35]">
                                        {item.question}
                                    </span>

                                    <FaChevronDown
                                        className={`transition-transform duration-300 text-[#FF6B35] 
                                    ${activeIndex === index ? "rotate-180" : ""}`}
                                    />
                                </button>

                                {/* Answer */}
                                <div
                                    className={`px-6 overflow-hidden transition-all duration-300 
                                ${activeIndex === index
                                            ? "max-h-40 pb-5 opacity-100"
                                            : "max-h-0 opacity-0"
                                        }`}
                                >
                                    <p className="text-gray-600 text-sm leading-relaxed">
                                        {item.answer}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}